<template>
  <div class="box">
    <div v-if="$store.state.role === 'school-role'">
      <table-view
        :dataList="dataList"
        :pagination="pagination"
        :loading="loading"
        @deleteApply="deleteApply"
        @editInfo="editInfo"
        @getLxApplyApplylist="getLxApplyApplylist"
        @goQuery="goQuerySchool"
        :startTime="startTime"
        :endTime="endTime"
         titleType="xal"
        :btnShow="btnShow"
        :columns="columns"
      ></table-view>
    </div>
    <div v-if="$store.state.role === 'expert-role'">
      <expert-table-view
      	:columns='columns1'
        :pagination="pagination"
        :timestampStartTime="timestampStartTime"
        :timestampEndTime="timestampEndTime"
        :reviewStartTimestamp="reviewStartTimestamp"
        :reviewEndTimestamp="reviewEndTimestamp"
        :reviewStartTime="reviewStartTime"
        :reviewEndTime="reviewEndTime"
        :data="expertData"
        @updataInfo="updataInfo"
        @getApplyZjApplyList="getApplyZjApplyList"
        type="xal"
        :wokrName="'工作室'"
        :applyCount="applyCount"
        :schoolCount="schoolCount"
         :provinceCount="provinceCount"
        :reviewedCount="reviewedCount"
        :unreviewedCount="unreviewedCount"
      ></expert-table-view>
    </div>
    <div v-if="$store.state.role === 'education-role'">
      <a-spin :spinning="spinning" tip="文件导出中,请稍等...">
        <education-table
        	:columns='columns2'
          :dataList="dataList"
          :pagination="pagination"
           @lxApplyExportExcel="lxApplyExportExcel"
          @getLxApplyjyjApplylist="getLxApplyjyjApplylist"
          @editInfo="editInfo"
          @lxApplyExportZip="lxApplyExportZip"
          @cancelApply="cancelApply"
          :applyCount="applyCount"
          :schoolCount="schoolCount"
          :provinceCount="provinceCount"
        />
      </a-spin>
    </div>
    <div v-if="$store.state.role === 'education-overall-role'">
      <a-spin :spinning="spinning" tip="文件导出中,请稍等...">
        <education-table
        	:columns='columns3'
          :dataList="dataList"
          :pagination="pagination"
           @lxApplyExportExcel="lxApplyExportExcels"
          @getLxApplyjyjApplylist="getLxApplyjytApplylist"
          @editInfo="editInfo"
          @lxApplyExportZip="lxApplyExportZips"
          @cancelApply="cancelApply"
          :applyCount="applyCount"
          :schoolCount="schoolCount"
          :provinceCount="provinceCount"
        />
      </a-spin>
    </div>
  </div>
</template>

<script>
import {
  lxApplyApplylist,
  lxApplyApplyDelete,
  applyDateView,
  expertDateView,
  lxApplyjApplylist,
  lxApplyZjApplyList,
  lxApplyExportZip,
  lxApplyExportZips,
  lxApplyExportExcel,
  lxApplyExportExcels,
  lxApplyApplyCancel,
  lxApplyApplyCancels,
  lxApplytApplylist
} from "@/api/index";
import { getTsFormatDate } from "@/utils/time";
import tableView from "@/components/common/tableView.vue";
import expertTableView from "@/components/common/expertTableView.vue";
import educationTable from "@/components/common/educationTable.vue";
export default {
  name: "",
  components: {
    tableView,
    expertTableView,
    educationTable,
  },
  props: {},
  data() {
    return {
    	columns2:[
    			{
		    title: "序号",
		    dataIndex: "sequenceNumber",
		    id: "sequenceNumber",
		    align: "center",
		    scopedSlots: { customRender: "sequenceNumber" },
		    width: 70,
//		  fixed: 'left'
  		},

		  {
		    title: "分社",
		    dataIndex: "branchName",
		    id: "branchName",
		    align: "center",
		    width: 140,
		  },
		  {
	    title: "学校",
	    dataIndex: "realname",
	    id: "realname",
	    align: "center",
	    width: 170,
  		},
		  {
		    title: '标题',
		    dataIndex: 'zpname',
		    id: 'zpname',
		    align: 'center',
		    scopedSlots: { customRender: "zpname" },
		    width: 150,
		  },
		  {
		    title: "案例联系人",
		    dataIndex: "principals",
		    id: "principals",
		    align: "center",
		    width: 120,
		  },
		  {
		    title: "联系电话",
		    dataIndex: "phone",
		    id: "phone",
		    align: "center",
		    width: 100,
		  },
//		  {
//		    title: "资料完整",
//		    dataIndex: "applyFilesFull",
//		    id: "applyFilesFull",
//		    align: "center",
//		    scopedSlots: { customRender: "applyFilesFull" },
//		    width: 90,
//		  },
       {
		    title: '提交状态',
		    dataIndex: 'subState',
		    id: 'subState',
		    align: 'center',
		    scopedSlots: { customRender: 'subState' },
		    width: 100,
		  },
		  {
		    title: "评审专家",
		    dataIndex: "applyFiles",
		    id: "applyFiles",
		    align: "center",
		    scopedSlots: { customRender: "applyFiles" },
		    width: 100,
//		    fixed: 'right' 
		  },
		  {
		    title: "评分",
		    dataIndex: "score",
		    id: "score",
		    align: "center",
		    scopedSlots: { customRender: "score" },
		    width: 90, 
		  },
		  {
		    title: '评审状态',
		    dataIndex: 'izReview',
		    id: 'izReview',
		    align: 'center',
		    scopedSlots: { customRender: 'izReview' },
		    width: 115,
		  },
//		  {
//		    title: "评审表",
//		    dataIndex: "examine",
//		    id: "examine",
//		    align: "center",
//		    scopedSlots: { customRender: "examine" },
//		    width: 85,
////		    fixed: 'right' 
//		  },
		  {
		    title: "均分",
		    dataIndex: "avgscore",
		    id: "avgscore",
		    align: "center",
		    scopedSlots: { customRender: "avgscore" },
		    width: 70,
		  },
      {
			   title: "操作",
			   id: "action",
			   align: "center",
			   scopedSlots: { customRender: "action" },
			   width: 80,
			},
    	],
      columns3:[
    			{
		    title: "序号",
		    dataIndex: "sequenceNumber",
		    id: "sequenceNumber",
		    align: "center",
		    scopedSlots: { customRender: "sequenceNumber" },
		    width: 70,
//		  fixed: 'left' 
  		},
      
		  {
		    title: "省",
		    dataIndex: "provinceName",
		    id: "provinceName",
		    align: "center",
		    width: 70,
		  },
		  {
	    title: "学校",
	    dataIndex: "realname",
	    id: "realname",
	    align: "center",
	    width: 170,
  		},
		  {
		    title: '标题',
		    dataIndex: 'zpname',
		    id: 'zpname',
		    align: 'center',
		    scopedSlots: { customRender: "zpname" },
		    width: 150,
		  },
		  {
		    title: "案例联系人",
		    dataIndex: "principals",
		    id: "principals",
		    align: "center",
		    width: 120,
		  },
		  {
		    title: "联系电话",
		    dataIndex: "phone",
		    id: "phone",
		    align: "center",
		    width: 100,
		  },
//		  {
//		    title: "资料完整",
//		    dataIndex: "applyFilesFull",
//		    id: "applyFilesFull",
//		    align: "center",
//		    scopedSlots: { customRender: "applyFilesFull" },
//		    width: 90,
//		  },
       {
		    title: '提交状态',
		    dataIndex: 'subState',
		    id: 'subState',
		    align: 'center',
		    scopedSlots: { customRender: 'subState' },
		    width: 100,
		  },
		  {
		    title: "评审专家",
		    dataIndex: "applyFiles",
		    id: "applyFiles",
		    align: "center",
		    scopedSlots: { customRender: "applyFiles" },
		    width: 100,
//		    fixed: 'right' 
		  },
		  {
		    title: "评分",
		    dataIndex: "score",
		    id: "score",
		    align: "center",
		    scopedSlots: { customRender: "score" },
		    width: 90, 
		  },
		  {
		    title: '评审状态',
		    dataIndex: 'izReview',
		    id: 'izReview',
		    align: 'center',
		    scopedSlots: { customRender: 'izReview' },
		    width: 115,
		  },
//		  {
//		    title: "评审表",
//		    dataIndex: "examine",
//		    id: "examine",
//		    align: "center",
//		    scopedSlots: { customRender: "examine" },
//		    width: 85,
////		    fixed: 'right' 
//		  },
		  {
		    title: "均分",
		    dataIndex: "avgscore",
		    id: "avgscore",
		    align: "center",
		    scopedSlots: { customRender: "avgscore" },
		    width: 70,
		  },
      // {
			//    title: "操作",
			//    id: "action",
			//    align: "center",
			//    scopedSlots: { customRender: "action" },
			//    width: 80,
			// },
    	],
    	columns1:[
			  {
			    title: '序号',
			    dataIndex: 'sequenceNumber',
			    id: 'sequenceNumber',
			    align: 'center',
			    scopedSlots: { customRender: 'sequenceNumber' },
			    width: 70,
//			    fixed: 'left',
			  },
			  {
			    title: '省份',
			    dataIndex: 'provinceName',
			    id: 'provinceName',
			    align: 'center',
			    width: 130,
			  },
//			  {
//			    title: '学校名称',
//			    dataIndex: 'realname',
//			    id: 'realname',
//			    align: 'center',
//			    width: 170,
//			  },
			  {
			    title: '标题',
			    dataIndex: 'zpname',
			    id: 'zpname',
			    align: 'center',
			    width: 180,
			  },
//			  {
//			    title: '案例联系人',
//			    dataIndex: 'principals',
//			    id: 'principals',
//			    align: 'center',
//			    width: 120,
//			  },
//			  {
//			    title: '联系电话',
//			    dataIndex: 'phone',
//			    key: 'phone',
//			    align: 'center',
//			    width: 120,
//			  },
			  {
			    title: '资料完整',
			    dataIndex: 'applyFilesFull',
			    id: 'applyFilesFull',
			    align: 'center',
			    scopedSlots: { customRender: 'applyFilesFull' },
			    width:100,
			  },
//			  {
//			    title: '分数',
//			    dataIndex: 'score',
//			    key: 'score',
//			    align: 'center',
//			    width: 70,
//			  },
//			  {
//			    title: '评审表',
//			    dataIndex: 'scoreFile',
//			    key: 'scoreFile',
//			    align: 'center',
//			    scopedSlots: { customRender: 'applyScoreFile' },
//			    width: 150,
//			  },
				{
			    title: '评审状态',
			    dataIndex: 'izReview',
			    key: 'izReview',
			    align: 'center',
			    scopedSlots: { customRender: 'izReview' },
			    width: 150,
			  },
			  {
			    title: "评分",
			    dataIndex: "score",
			    id: "score",
			    align: "center",
			    width: 90, 
		    },
			  {
			    title: '操作',
			    key: 'action',
			    align: 'center',
			    width: 150,
			    scopedSlots: { customRender: 'action' },
//			    fixed: 'right',
			  },
    	],
    	columns:[
    	{
		    title: "序号",
		    dataIndex: "sequenceNumber",
		    id: "sequenceNumber",
		    align: "center",
		    scopedSlots: { customRender: "sequenceNumber" },
		    width: 70,
//		    fixed: 'left' 
  		},
  		{
		    title: '标题',
		    dataIndex: 'zpname',
		    id: 'zpname',
		    align: 'center',
		    width: 160,
		  },
		  {
		    title: '大赛分组',
		    dataIndex: 'levelType',
		    id: 'levelType',
		    align: 'center',
		    scopedSlots: { customRender: 'levelType' },
		    width: 90,
		  },
		  // {
		  //   title: '团队类型',
		  //   dataIndex: 'teamType',
		  //   id: 'teamType',
		  //   align: 'center',
		  //   scopedSlots: { customRender: 'teamType' },
		  //   width: 90,
		  // },
		  {
		    title: '案例联系人',
		    dataIndex: 'principals',
		    id: 'principals',
		    align: 'center',
		    width: 100,
		  },
		  {
		    title: "联系电话",
		    dataIndex: "phone",
		    id: "phone",
		    align: "center",
		    width: 100,
		  },
		  {
		    title: '资料完整',
		    dataIndex: 'applyFilesFull',
		    id: 'applyFilesFull',
		    align: 'center',
		    scopedSlots: { customRender: 'applyFilesFull' },
		    width: 90,
		  },
		  {
		    title: '提交状态',
		    dataIndex: 'subState',
		    id: 'subState',
		    align: 'center',
		    scopedSlots: { customRender: 'subState' },
		    width: 80,
		  },
//		  {
//		    title: "评审专家",
//		    dataIndex: "applyFiles",
//		    id: "applyFiles",
//		    align: "center",
//		    scopedSlots: { customRender: "applyFiles" },
//		    width: 100,
//		   },
//		  {
//		    title: '评审状态',
//		    dataIndex: 'izReview',
//		    id: 'izReview',
//		    align: 'center',
//		    scopedSlots: { customRender: 'izReview' },
//		    width: 80,
//		  },
//			 {
//		    title: "最终成绩",
//		    dataIndex: "avgscore",
//		    id: "avgscore",
//		    align: "center",
//		    scopedSlots: { customRender: "avgscore" },
//		    width: 70,
//		  },
		  {
		    title: '操作',
			  key: 'action',
			  align: 'center',
			  width: 200,
			  scopedSlots: { customRender: 'action' },
		  }],
      isShowView: false,
      dataList: [],
      loading: true,
      pagination: {
        total: 0,
        current: 1,
        pageSize: 20, //每页中显示10条数据
        showTotal: ((total) => {
          return `共 ${total} 条`;
        }),
      },
      startTime: "",
      endTime: "",
      // 评审时间
      reviewStartTime: "",
      reviewEndTime: "",
      btnShow: true,
      timestampStartTime: "",
      timestampEndTime: "",
      expertData: [], //专家表格内容
      // 评审时间戳
      reviewStartTimestamp: "",
      reviewEndTimestamp: "",
      applyCount: 0,
      schoolCount: 0,
      provinceCount:0,
      reviewedCount: 0,
      unreviewedCount: 0,
      spinning: false,
    };
  },
  computed: {},
  watch: {},
  created() {
  	sessionStorage.removeItem('qbsj');
  },
  mounted() {
    if (this.$store.state.role === "school-role") {
//  	this.getexpertDateView();
      this.getLxApplyApplylist({
        page: 1,
        size: 20,
      });
      this.getapplyDateView();
    }
    if (this.$store.state.role === "education-role") {
      this.getLxApplyjyjApplylist({
        page: 1,
        size: 20,
      });
    }
    if (this.$store.state.role === "education-overall-role") {
      this.getLxApplyjytApplylist({
        page: 1,
        size: 20,
      });
    }
    if (this.$store.state.role === "expert-role") {
      this.getApplyZjApplyList({
        page: 1,
        size: 20,
      });
      this.getexpertDateView();
    }
  },
  methods: {
    updataInfo() {
      this.getApplyZjApplyList({
        page: 1,
        size: 20,
      });
    },
    // 学校列表
    getLxApplyApplylist(pagination) {
      this.loading = true;
      let data = {
        applyType: "",
        pageNo: pagination.page,
        pageSize: pagination.size,
      };
      if (pagination.realname != "") {
        data.schoolName = pagination.realname;
      }
      if (pagination.name != "") {
        data.name = pagination.name;
      }
      if (pagination.principals != "") {
        data.principals = pagination.principals;
      }
      if (pagination.Integrity != "") {
        data.applyFilesFull = pagination.Integrity;
      }
      if (pagination.zpname != "") {
        data.zpname = pagination.zpname;
      }
      if (pagination.levelType) {
        data.levelType = pagination.levelType;
      }
      // if (pagination.teamType) {
      //   data.teamType = pagination.teamType;
      // }
      if (this.$route.name === "szStudio") {
        data.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        data.applyType = 2;
      } else {
        data.applyType = 3;
      }
      if(this.$route.name === "alApply"){
      	data.applyType = 4;
      }else if(this.$route.name === "xal"){
        data.applyType = 1;
      }
      lxApplyApplylist(data).then((res) => {
        if (res.code === 200) {
          let data = res.result.records;
          if (data) {
            this.dataList = data;
            this.pagination.total = res.result.total;
          }
        }
        this.loading = false;
      });
    },
    getLxApplyjytApplylist(pagination) {
      this.loading = true;
      let data = {
        applyType: "",
        pageNo: pagination.page,
        pageSize: pagination.size,
        // subState:pagination.subState,
        subState:1,
      };
      if (pagination.realname != "") {
        data.schoolName = pagination.realname;
      }
      if (pagination.name != "") {
        data.name = pagination.name;
      }
      if (pagination.zpname != "") {
        data.zpname = pagination.zpname;
      }
      if (pagination.principals != "") {
        data.principals = pagination.principals;
      }
      if (pagination.Integrity != "") {
        data.applyFilesFull = pagination.Integrity;
      }
      if(pagination.provincecode != "") {
        data.provincecode = pagination.provincecode;
      }
      if (pagination.branchName != "") {
        data.branchName = pagination.branchName;
      }
      if (this.$route.name === "szStudio") {
        data.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        data.applyType = 2;
      } else {
        data.applyType = 3;
      }
      if(this.$route.name === "alApply"){
      	data.applyType = 4;
      }else if(this.$route.name === "xal"){
        data.applyType = 1;
      }
      lxApplytApplylist(data).then((res) => {
        if (res.code === 200) {
          let data = JSON.parse(JSON.stringify(res.result.pageList.records));
          if (data) {
            this.dataList = data;
            this.pagination.total = res.result.pageList.total;
            this.applyCount = res.result.applyCount;
            this.schoolCount = res.result.schoolCount;
            if(this.$route.name === "alApply" || this.$route.name === "xal"){
      	      this.provinceCount=res.result.provinceCount; 
      			}
            
          }
        }
        this.loading = false;
      });
    },
    // 教育局列表
    getLxApplyjyjApplylist(pagination) {
      this.loading = true;
      let data = {
        applyType: "",
        pageNo: pagination.page,
        pageSize: pagination.size,
        subState:pagination.subState,
      };
      if (pagination.realname != "") {
        data.schoolName = pagination.realname;
      }
      if (pagination.name != "") {
        data.name = pagination.name;
      }
      if (pagination.zpname != "") {
        data.zpname = pagination.zpname;
      }
      if (pagination.principals != "") {
        data.principals = pagination.principals;
      }
      if (pagination.Integrity != "") {
        data.applyFilesFull = pagination.Integrity;
      }
      if(pagination.provincecode != "") {
        data.provincecode = pagination.provincecode;
      }
      if (pagination.branchName != "") {
        data.branchName = pagination.branchName;
      }
      if (this.$route.name === "szStudio") {
        data.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        data.applyType = 2;
      } else {
        data.applyType = 3;
      }
      if(this.$route.name === "alApply"){
      	data.applyType = 4;
      }else if(this.$route.name === "xal"){
        data.applyType = 1;
      }
      lxApplyjApplylist(data).then((res) => {
        if (res.code === 200) {
          let data = JSON.parse(JSON.stringify(res.result.pageList.records));
          if (data) {
            this.dataList = data;
            this.pagination.total = res.result.pageList.total;
            this.applyCount = res.result.applyCount;
            this.schoolCount = res.result.schoolCount;
            if(this.$route.name === "alApply" || this.$route.name === "xal"){
      	      this.provinceCount=res.result.provinceCount; 
      			}
            
          }
        }
        this.loading = false;
      });
    },
    // 获取专家列表
    getApplyZjApplyList(pagination) {
      let data = {
        applyType: "",
        pageNo: pagination.page,
        pageSize: pagination.size,
      };
      if (pagination.realname != "") {
        data.schoolName = pagination.realname;
      }
      if (pagination.name != "") {
        data.name = pagination.name;
      }
      if (pagination.zpname != "") {
        data.zpname = pagination.zpname;
      }
      if (pagination.principals != "") {
        data.principals = pagination.principals;
      }
      if (pagination.Integrity != "") {
        data.applyFilesFull = pagination.Integrity;
      }
      if(pagination.provincecode != "") {
        data.provincecode = pagination.provincecode;
      }
      if (pagination.branchName != "") {
        data.branchName = pagination.branchName;
      }
      if (pagination.levelType) {
        data.levelType = pagination.levelType;
      }
      if (pagination.chapterOrderNum) {
        data.chapterOrderNum = pagination.chapterOrderNum;
      }
      if (pagination.reviewStatus) {
        data.reviewStatus = pagination.reviewStatus;
      }
      if (this.$route.name === "szStudio") {
        data.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        data.applyType = 2;
      } else {
        data.applyType = 3;
      }
      if(this.$route.name === "alApply"){
      	data.applyType = 4;
      }else if(this.$route.name === "xal"){
        data.applyType = 1;
      }
      lxApplyZjApplyList(data).then((res) => {
        if (res.code === 200) {
          this.expertData = res.result.pageList.records;
          this.applyCount = res.result.applyCount;
          this.schoolCount = res.result.schoolCount;
          this.reviewedCount = res.result.reviewedCount;
          this.unreviewedCount = res.result.unreviewedCount;
          if(this.$route.name === "alApply" || this.$route.name === "xal"){
      	    this.provinceCount=res.result.provinceCount; 
      		}
          this.pagination.total = res.result.pageList.total;
        }
      });
    },
    cancelApply(canceldata){
    	lxApplyApplyCancel(canceldata).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message);
          this.pagination.current=1;
          this.getLxApplyjyjApplylist({
            page: 1,
            size: 20,
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    deleteApply(id) {
      lxApplyApplyDelete({ id }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message);
          this.getLxApplyApplylist({
            page: 1,
            size: 20,
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    editInfo(params, type) {
      params.type = type;
      this.$router.push({ name: `${this.$route.name}DataUpload`, params });
    },
    // 获取申报时间
    getapplyDateView() {
      applyDateView().then((res) => {
        if (res.code == 200) {
          this.timestampStartTime = res.result.startTime;
          this.timestampEndTime = res.result.endTime;
          var startTime = parseInt(res.result.startTime);
          var endTime = parseInt(res.result.endTime);
          this.startTime = getTsFormatDate(startTime);
          this.endTime = getTsFormatDate(endTime);
          var date1 = new Date();
          var timestamp = Date.parse(date1);
          if (timestamp < this.timestampStartTime) {
            this.btnShow = false;
          } else if (timestamp > this.timestampEndTime) {
            this.btnShow = false;
          } else if (
            timestamp > this.timestampStartTime &&
            timestamp < this.timestampEndTime
          ) {
            this.btnShow = true;
          }
        }
      });
    },
    // 获取评审时间
    getexpertDateView() {
      expertDateView().then((res) => {
        if (res.code == 200) {
          var startTime = parseInt(res.result.startTime);
          var endTime = parseInt(res.result.endTime);
          this.reviewStartTime = getTsFormatDate(startTime);
          this.reviewEndTime = getTsFormatDate(endTime);
          this.reviewStartTimestamp = res.result.startTime;
          this.reviewEndTimestamp = res.result.endTime;
          console.log(this.reviewStartTimestamp,this.reviewEndTimestamp);
        }
      });
    },
    goQuery(query) {
      const pagination = {
        page: 1,
        size: 20,
        name: query.name,
        principals: query.principals,
        schoolName: query.schoolName,
        Integrity: query.Integrity,
      };
      this.getApplyZjApplyList(pagination);
    },
    goQuerySchool(query) {
      const pagination = {
        page: 1,
        size: 20,
        name: query.name,
        principals: query.principals,
        Integrity: query.Integrity,
      };
      this.getLxApplyApplylist(pagination);
    },
    lxApplyExportExcel(data){
//     console.log(data);
      this.spinning = true;
      let params = {};
      if (this.$route.name === "szStudio") {
        params.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        params.applyType = 2;
      } else {
        params.applyType = 3;
      }
      if (this.$route.name === "alApply") {
        params.applyType = 4;
      }else if(this.$route.name === "xal"){
        params.applyType = 1;
      }
      if (data.schoolName != "") {
        params.schoolName = data.schoolName;
      }
      if (data.workroomName != "") {
        params.name = data.workroomName;
      }
      if (data.projectPrincipal != "") {
        params.principals = data.projectPrincipal;
      }
      if (data.Integrity != "") {
        params.applyFilesFull = data.Integrity;
      }
      if(data.provincecode != "") {
        params.provincecode = data.provincecode;
      }
//    console.log(this.$route.name);
      params.subState=1;
      lxApplyExportExcel(params).then((res) => {
//      let url = window.URL.createObjectURL(
//        new Blob([res], { type: "application/zip" })
//      );
//      let link = document.createElement("a");
//      link.style.display = "none";
//      link.href = url;
				if (!res) {
	          this.$message.warning('文件下载失败')
	          return
        }
        let fileName = "";
        if (this.$route.name === "szStudio") {
          fileName = "思政工作室";
        } else if (this.$route.name === "educationalBrand") {
          fileName = "特色文化育人品牌";
        } else if (this.$route.name === "alApply") {
          fileName = "网络育人创新联盟";
        }else if (this.$route.name === "xal") {
          fileName = "典型小案例申报";
        }else {
          fileName = "思政微课";
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
	          window.navigator.msSaveBlob(new Blob([res], { type: 'application/vnd.ms-excel' }), fileName + '.xls')
	      } else {
	          let url = window.URL.createObjectURL(new Blob([res], { type: 'application/vnd.ms-excel' }))
	          let link = document.createElement('a')
	          link.style.display = 'none'
	          link.href = url
	          link.setAttribute('download', fileName + '.xls')
	          document.body.appendChild(link)
	          link.click()
	          document.body.removeChild(link) // 下载完成移除元素
	          window.URL.revokeObjectURL(url) // 释放掉blob对象
	      }
//      link.setAttribute("download", `${fileName}遴选作品批量下载` + ".zip");
//      document.body.appendChild(link);
//      link.click();
//      document.body.removeChild(link); //下载完成移除元素
//      window.URL.revokeObjectURL(url); //释放掉blob对象
        this.spinning = false;
      });
    },
    lxApplyExportExcels(data){
//     console.log(data);
      this.spinning = true;
      let params = {};
      if (this.$route.name === "szStudio") {
        params.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        params.applyType = 2;
      } else {
        params.applyType = 3;
      }
      if (this.$route.name === "alApply") {
        params.applyType = 4;
      }else if(this.$route.name === "xal"){
        params.applyType = 1;
      }
      if (data.schoolName != "") {
        params.schoolName = data.schoolName;
      }
      if (data.workroomName != "") {
        params.name = data.workroomName;
      }
      if (data.projectPrincipal != "") {
        params.principals = data.projectPrincipal;
      }
      if (data.Integrity != "") {
        params.applyFilesFull = data.Integrity;
      }
      if(data.provincecode != "") {
        params.provincecode = data.provincecode;
      }
//    console.log(this.$route.name);
      params.subState=1;
      lxApplyExportExcels(params).then((res) => {
//      let url = window.URL.createObjectURL(
//        new Blob([res], { type: "application/zip" })
//      );
//      let link = document.createElement("a");
//      link.style.display = "none";
//      link.href = url;
				if (!res) {
	          this.$message.warning('文件下载失败')
	          return
        }
        let fileName = "";
        if (this.$route.name === "szStudio") {
          fileName = "思政工作室";
        } else if (this.$route.name === "educationalBrand") {
          fileName = "特色文化育人品牌";
        } else if (this.$route.name === "alApply") {
          fileName = "网络育人创新联盟";
        }else if (this.$route.name === "xal") {
          fileName = "典型小案例申报";
        }else {
          fileName = "思政微课";
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
	          window.navigator.msSaveBlob(new Blob([res], { type: 'application/vnd.ms-excel' }), fileName + '.xls')
	      } else {
	          let url = window.URL.createObjectURL(new Blob([res], { type: 'application/vnd.ms-excel' }))
	          let link = document.createElement('a')
	          link.style.display = 'none'
	          link.href = url
	          link.setAttribute('download', fileName + '.xls')
	          document.body.appendChild(link)
	          link.click()
	          document.body.removeChild(link) // 下载完成移除元素
	          window.URL.revokeObjectURL(url) // 释放掉blob对象
	      }
//      link.setAttribute("download", `${fileName}遴选作品批量下载` + ".zip");
//      document.body.appendChild(link);
//      link.click();
//      document.body.removeChild(link); //下载完成移除元素
//      window.URL.revokeObjectURL(url); //释放掉blob对象
        this.spinning = false;
      });
    },
    lxApplyExportZip(data) {
//    console.log(data);
      this.spinning = true;
      let params = {};
      if (this.$route.name === "szStudio") {
        params.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        params.applyType = 2;
      } else {
        params.applyType = 3;
      }
      if (this.$route.name === "alApply") {
        params.applyType = 4;
      }else if (this.$route.name === "xal") {
        params.applyType = 1;
      }
      if (data.schoolName != "") {
        params.schoolName = data.schoolName;
      }
      if (data.workroomName != "") {
        params.name = data.workroomName;
      }
      if (data.projectPrincipal != "") {
        params.principals = data.projectPrincipal;
      }
      if (data.Integrity != "") {
        params.applyFilesFull = data.Integrity;
      }
      if(data.provincecode != "") {
        params.provincecode = data.provincecode;
      }
      params.subState=data.subState;
//    console.log(this.$route.name);
      lxApplyExportZip(params).then((res) => {
        let url = window.URL.createObjectURL(
          new Blob([res], { type: "application/zip" })
        );
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        let fileName = "";
        if (this.$route.name === "szStudio") {
          fileName = "思政工作室";
        } else if (this.$route.name === "educationalBrand") {
          fileName = "特色文化育人品牌";
        } else if (this.$route.name === "alApply") {
          fileName = "网络育人创新联盟";
        }else if (this.$route.name === "xal") {
          fileName = "典型小案例申报";
        }else {
          fileName = "思政微课";
        }
        link.setAttribute("download", `${fileName}遴选作品批量下载` + ".zip");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); //下载完成移除元素
        window.URL.revokeObjectURL(url); //释放掉blob对象
        this.spinning = false;
      });
    },
     lxApplyExportZips(data) {
//    console.log(data);
      this.spinning = true;
      let params = {};
      if (this.$route.name === "szStudio") {
        params.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        params.applyType = 2;
      } else {
        params.applyType = 3;
      }
      if (this.$route.name === "alApply") {
        params.applyType = 4;
      }else if (this.$route.name === "xal") {
        params.applyType = 1;
      }
      if (data.schoolName != "") {
        params.schoolName = data.schoolName;
      }
      if (data.workroomName != "") {
        params.name = data.workroomName;
      }
      if (data.projectPrincipal != "") {
        params.principals = data.projectPrincipal;
      }
      if (data.Integrity != "") {
        params.applyFilesFull = data.Integrity;
      }
      if(data.provincecode != "") {
        params.provincecode = data.provincecode;
      }
      params.subState=1;
//    console.log(this.$route.name);
      lxApplyExportZips(params).then((res) => {
        let url = window.URL.createObjectURL(
          new Blob([res], { type: "application/zip" })
        );
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        let fileName = "";
        if (this.$route.name === "szStudio") {
          fileName = "思政工作室";
        } else if (this.$route.name === "educationalBrand") {
          fileName = "特色文化育人品牌";
        } else if (this.$route.name === "alApply") {
          fileName = "网络育人创新联盟";
        }else if (this.$route.name === "xal") {
          fileName = "典型小案例申报";
        }else {
          fileName = "思政微课";
        }
        link.setAttribute("download", `${fileName}遴选作品批量下载` + ".zip");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); //下载完成移除元素
        window.URL.revokeObjectURL(url); //释放掉blob对象
        this.spinning = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 100%;
  // max-height: 635px;
  overflow-y: auto;
  padding: 19px 30px;
  min-height: 450px;
}
</style>
